import {
  emptyNodeDataObject,
  updateActiveMachineStructureNode,
  updateNodeSelectionNodeData,
  updateNodeSelectionNodeEditedState,
  updateNodeSelectionState,
} from "@src/reducers/your-reducer";
import createFolderIcon from "@src/assets/svg/create-folder-blue-icon.svg";
import createFolderIconInactive from "@src/assets/svg/create-folder-inactive-blue-icon.svg";
import { RootState } from "@src/reducers/store";
import { useDispatch, useSelector } from "react-redux";
import { buildNodeSelectionOurNodeData } from "./build-node-selection-our-node-data";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { useEffect, useState } from "react";

export const useControlBarCreateFolderButtonHook = () => {
  const dispatch = useDispatch();

  const machineStructureNodeset = getMachineStructureNodeset();

  const [isFilterViewActive, setIsFilterViewActive] = useState(false);

  const nodeSelectionNodeData = useSelector(
    (state: RootState) => state.yourSlice.nodeSelection.nodeData,
  );

  const activeMachineStructureNode = useSelector(
    (state: RootState) => state.yourSlice.activeMachineStructureNode,
  );

  useEffect(() => {
    const updateIsFilterViewActive = () => {
      setIsFilterViewActive(
        machineStructureNodeset.getFilteredFlatMap().size > 0 ? true : false,
      );
    };

    machineStructureNodeset.addObserver(updateIsFilterViewActive);

    return () => {
      machineStructureNodeset.removeObserver(updateIsFilterViewActive);
    };
  }, [machineStructureNodeset.getFilteredFlatMap()]);

  const handleCreateFolderIsDisabled = () => {
    if (isFilterViewActive) {
      return true;
    }

    // only if you select / active an node in the list
    return nodeSelectionNodeData.key !== "" && activeMachineStructureNode !== ""
      ? false
      : true;
  };

  const getCreateFolderIcon = () => {
    return handleCreateFolderIsDisabled()
      ? createFolderIconInactive
      : createFolderIcon;
  };

  const closePanelAndFlushNodeData = () => {
    dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
    dispatch(updateNodeSelectionNodeEditedState(false));
    dispatch(updateNodeSelectionState("none"));
  };

  const createFolderHandler = () => {
    closePanelAndFlushNodeData();

    const nodeManager = getNodeManager();

    const newFolder = nodeManager
      .getCreateFolderHandler()
      .createFolder(nodeSelectionNodeData);

    dispatch(updateActiveMachineStructureNode(newFolder.key));
    dispatch(
      updateNodeSelectionNodeData(buildNodeSelectionOurNodeData(newFolder)),
    );
    dispatch(updateNodeSelectionNodeEditedState(true));
  };

  return {
    getCreateFolderIcon,
    createFolderHandler,
    handleCreateFolderIsDisabled,
  };
};
